import { combineReducers } from "redux"
import authReducer from "./auth"
import pageSlice from './newsletter'
import subscriptionCreated from "./subscriptionCreated"

export const rootReducer = combineReducers({
    auth: authReducer,
    page : pageSlice,
    subscriptionCreated : subscriptionCreated
})